module.exports = __webpack_public_path__ + "static/media/family_illustration.6453f9be.png";